<template>
  <div class="banner">Hybrid designer and developer with an obsession for clean, intuitive design.</div>
</template>

<script>
export default {
  name: "Banner"
};
</script>

